/** Wraps its child with `wrapper` only while `condition` is truthy, handing the wrapper the narrowed condition. Replaces hand-written `cond ? <Wrapper>{x}</Wrapper> : x` helpers. */ export function ConditionalWrapper(props) {
    const { condition, wrapper, children } = props;
    return condition ? wrapper(children, condition) : children;
}
